import { LocalStorageStore } from '@localStore';
import { TranslocoService } from '@jsverse/transloco';
import { inject } from '@angular/core';
import { LANGUAGE_STORAGE_KEY } from '../constants/i18n.constants';

/**
 * Initializes the internationalization (i18n) flow by subscribing to language changes
 * and updating the locale and date locale accordingly. The selected language is stored
 * in local storage.
 */
export const i18nInit = (setActionsOnLanguageChanges?: (lang: string) => void): void => {
  const localStore = inject(LocalStorageStore);
  const { langChanges$ } = inject(TranslocoService);

  langChanges$.subscribe((lang: string) => {
    if (setActionsOnLanguageChanges) {
      setActionsOnLanguageChanges(lang);
    }

    // Save the selected language to local storage
    localStore.setItem(LANGUAGE_STORAGE_KEY, lang);
  });
};
